export default {
  props: {
    rules: [String, Object],
  },
};
